angular.module("app").service( 'slugNameResolver', function(){
    var store = {};
    /**
     * Add page in store
     * @param slugName
     * @param pageId
     */
    this.addPage = function (slugName, pageId) {
        store[pageId] = {
            name: slugName,
            children: {}
        };
    };
    /**
     * Add child into parentPageId container
     * @param parentPageId
     * @param pageId
     * @param slugName
     */
    this.addChild = function(parentPageId, pageId, slugName ) {
        if (store[parentPageId] !== undefined){
            store[parentPageId].children[pageId] = {
                children: {}
            };
            if (slugName) {
                store[parentPageId].children[pageId].name = slugName;
            }
            store[parentPageId].children[pageId].parent = store[parentPageId];
        } else {
            for(var id in store) {
                if (store.hasOwnProperty(id)) {
                   var item = this.getPage(store[id].children, parentPageId);
                    if (item) {
                        item.children[pageId] = {};
                        slugName !== undefined && (item.children[pageId].name = slugName);
                        item.children[pageId].parent = item;
                        break;
                    }
                }
            }
        }
    };
    /**
     * Get page with given pageId in given container recursively
     * @param container
     * @param pageId
     * @returns {*}
     */
    this.getPage = function(container, pageId){
      for(var key in container){
          if (container.hasOwnProperty(key)) {
              if (key === pageId) {
                  return container[key];
              } else {
                 return this.getPage(container[key].children, pageId);
              }
          }
      }
    }

    this.getSlugName = function (parentPageId) {
        if (store[parentPageId] !== undefined){
            return store[parentPageId].name;
        } else {
            for(var id in store) {
                if (store.hasOwnProperty(id)) {
                    var item = this.getPage(store[id].children, parentPageId);
                    if(item !== undefined){
                        while(item.name === undefined){
                            item = item.parent;
                        }
                        return item.name;
                    }
                }
            }
        }

    }

});